import { CRYPTO_KEYS } from 'resources'
import { bitcoinIcon, ethereumIcon, usdcIcon, bitcoinPurpleIcon, ethereumPurpleIcon } from 'resources/images'

export const CRYPTO_CONFIGS = {
  [CRYPTO_KEYS.ETHEREUM]: {
    icon: ethereumIcon,
    purpleIcon: ethereumPurpleIcon,
  },
  [CRYPTO_KEYS.BITCOIN]: {
    icon: bitcoinIcon,
    purpleIcon: bitcoinPurpleIcon,
  },
  [CRYPTO_KEYS.USDC]: {
    icon: usdcIcon,
    purpleIcon: null,
  },
}
